import { render, staticRenderFns } from "./OrganDetail.vue?vue&type=template&id=6ce94882&scoped=true&"
import script from "./OrganDetail.vue?vue&type=script&lang=js&"
export * from "./OrganDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrganDetail.vue?vue&type=style&index=0&id=6ce94882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce94882",
  null
  
)

export default component.exports